import { ApplicationConfig, APP_INITIALIZER } from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';
import { APP_ROUTES } from './app.routes';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { provideHttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { provideAnimations } from '@angular/platform-browser/animations';
import DictionaryService from './services/dictionary.service';

export function initializeDictionary(dictionaryService: DictionaryService) {
	return () => dictionaryService.loadDictionary();
}

export const appConfig: ApplicationConfig = {
	providers: [
		provideRouter(APP_ROUTES, withRouterConfig({onSameUrlNavigation: 'reload'})),
		{ provide: LocationStrategy, useClass: HashLocationStrategy },
		provideHttpClient(),
		DatePipe,
		provideAnimations(),
		{
			provide: APP_INITIALIZER,
			useFactory: initializeDictionary,
			deps: [DictionaryService],
			multi: true,
		},
	]
};
